// extracted by mini-css-extract-plugin
export default {"cardBox":"CardWrapper_cardBox__PereL","card":"CardWrapper_card__+QChC"};